<template>
  <v-layout column class="inner-pages">
    <Header  />

    <v-flex class="sfh-login-form background-image text-xs-center signup-page scrollbar scroll-style-15" >

      <v-stepper v-model="e1" class="elevation-0" style="background: transparent;">
        <v-stepper-items>
          <v-stepper-content step="1">
            <confirm-my-email
              v-if="step === 'confirm-my-email'"
            />
            <code-verification
              v-if="step === 'code-verification'"
            />
          </v-stepper-content>

          <v-stepper-content step="2">
            <store-verification
              v-if="step === 'store-verification'"
            />
          </v-stepper-content>

          <v-stepper-content step="3">
            <get-name-and-pwd />
          </v-stepper-content>

        </v-stepper-items>
      </v-stepper>
    </v-flex>
  </v-layout>
</template>

<script>
import Header from '../../../layouts/Header'
import ConfirmMyEmail from './ConfirmMyEmail'
import CodeVerification from './CodeVerification'
import GetNameAndPwd from './GetNameAndPwd'
import {mapGetters} from 'vuex'
import StoreVerification from './StoreVerification.vue'

export default {
  name: 'SignUp',
  components: {
    StoreVerification,
    GetNameAndPwd,
    CodeVerification,
    ConfirmMyEmail,
    Header
  },
  data () {
    return {
      e1: 1
    }
  },
  computed: {
    step () {
      return this.$route.params.step
    },
    ...mapGetters('registration', ['getUserDetails'])
  },
  created () {
    this.setE1(this.$route.params.step)
    setTimeout(() => {
      this.$store.commit('setIsCompactHeader', false)
    }, 50)
  },
  methods: {
    setE1 (newVal) {
      switch (newVal) {
        case 'confirm-my-email': this.e1 = 1
          break
        case 'code-verification': this.e1 = 1
          break
        case 'store-verification': this.e1 = 2
          break
        case 'get-name-and-pwd': this.e1 = 3
          break
        default: this.e1 = 1
      }
    }
  },
  watch: {
    step (newVal) {
      this.setE1(newVal)
    }
  }
}
</script>


<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/views/sign-up/69/SignUp.vue